import React from 'react';

function StatCard({ title, value, unit = "", color }) {
  const c = {
    blue: "text-blue-400 border-blue-500/20 shadow-[0_0_25px_rgba(59,130,246,0.15)]",
    rose: "text-rose-400 border-rose-500/20 shadow-[0_0_25px_rgba(244,63,94,0.15)]",
    emerald: "text-emerald-400 border-emerald-500/20 shadow-[0_0_25px_rgba(16,185,129,0.15)]",
    orange: "text-orange-400 border-orange-500/20 shadow-[0_0_25px_rgba(249,115,22,0.15)]"
  };
  return (
    <div className={`bg-slate-900 p-10 rounded-[45px] border ${c[color]} hover:scale-105 hover:border-white/20 transition-all duration-500 group`}>
      <p className="text-slate-500 text-[10px] font-black uppercase tracking-[0.2em] mb-4 group-hover:text-slate-300 transition-colors">{title}</p>
      <div className={`text-4xl font-black tracking-tighter drop-shadow-[0_0_10px_currentColor]`}>{value} <span className="text-xs font-medium text-slate-600 ml-1">{unit}</span></div>
    </div>
  );
}

export default StatCard;
